<template>
  <div class="d-flex justify-content-center flex-wrap">
    <tool-header
      class="mb-3"
      tool-name="Gumbo Websocket Driver"
      tool-icon-text="Displays the status of the gumbo websocket for each of today's games" />
    <div class="d-flex justify-content-center">
      <div class="d-flex flex-column align-items-center">
        <button
          class="btn btn-primary mt-3"
          @click="reconnectAll">
          Reconnect all
        </button>
        <div class="d-flex justify-content-center flex-wrap mt-3">
          <div
            v-for="game in games"
            :key="game.gamePk"
            class="card mr-3 mb-3"
            :style="{
              width: '18rem',
              border: game.status.abstractGameState === 'Live' && gamePkConnectedMap.get(game.gamePk) ? '2px solid green': game.status.abstractGameState !== 'Live' ? '' : '2px solid red'}">
            <div class="card-body d-flex flex-column p-3">
              <h6 class="card-title text-center mb-3">
                {{ game.teams.away.team.name }} @ <br> {{ game.teams.home.team.name }}
              </h6>
              <p class="card-text text-center">
                <span
                  :class="getAbstractGameStateBadgeClass(game.status.abstractGameState)">
                  {{ game.status.abstractGameState }}
                </span>
              </p>
              <div class="container">
                <div class="row mt-3">
                  <span
                    class="col-12 text-center"
                    :class="{
                      'badge badge-success': gamePkConnectedMap.get(game.gamePk),
                      'badge badge-danger': !gamePkConnectedMap.get(game.gamePk)
                    }">
                    {{ gamePkConnectedMap.get(game.gamePk) ? 'Connected' : 'Disconnected' }}
                  </span>
                </div>
                <div class="row mt-3">
                  <button
                    v-if="!gamePkConnectedMap.get(game.gamePk)"
                    class="btn btn-primary btn-sm col-12 text-center" 
                    @click="reconnect(game.gamePk)">
                    Reconnect
                  </button>
                  <span v-if="!gamePkConnectedMap.get(game.gamePk)">
                    <p>Last fallback sent: {{ gamePkFallbackMap.get(game.gamePK) }}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {GumboWebsocketDriver} from '@/services/api'
import ToolHeader from '../components/ToolHeader.vue'

export default {
  name: "GumboWebsocketDriver",
  components: {ToolHeader},
  data(){
    return {
        games: [],
        gamePkConnectedMap: new Map(),
        gamePkFallbackMap: new Map(),
        date: this.$route.query.date,
        timeZone: this.$route.query.timeZone || 'America/New_York',
    }
  },
  async mounted() {
      try {
          const clientStatuses = await GumboWebsocketDriver.getClientStatuses()
          const response = await GumboWebsocketDriver.getSchedule(this.date, this.timeZone)
          this.games = response.dates[0].games
          
          this.buildConnectionStatusMap(clientStatuses)
      } catch (error) {
          console.error(error)
      }
  },
  methods: {
    async buildConnectionStatusMap(clientStatuses) {
        clientStatuses.clients.forEach(client => {
            const gamePkStr = client.socketUrl.split("/").pop()
            const gamePK = parseInt(gamePkStr)
            this.gamePkConnectedMap.set(gamePK, client.connected)
            this.gamePkFallbackMap.set(gamePK, client.lastFallbackMsgSent)
        })
    },
    async reconnect(gamePk) {
      try {
        await GumboWebsocketDriver.startClientForGamePk(gamePk)
        this.$alert.success('Reconnect successful')
        this.buildConnectionStatusMap()
      } catch (error) {
        /**
         * Reason why I'm adding a manual alert here and in `reconnectAll`:
         *
         * The original request to the `GumboWebsocketDriver` APIs end up with a redirect (302).
         * This prevents the alert in `common.js` from going off even when there is an error.
         */
        this.$alert.error(`Error reconnecting to ${gamePk}`)
        console.error(error)
      }
    },
    async reconnectAll() {
      try {
        await GumboWebsocketDriver.startAllSockets(this.date, this.timeZone)
        this.$alert.success('Reconnect all successful')
      } catch (error) {
        this.$alert.error(`Error reconnecting to all`)
        console.error(error)
      }
    },
    getAbstractGameStateBadgeClass(abstractGameState) {
        switch (abstractGameState) {
        case 'Live':
            return 'badge badge-pill badge-primary'
        case 'Final':
            return 'badge badge-pill badge-dark'
        case 'Preview':
            return 'badge badge-pill badge-secondary'
        default:
            return 'badge badge-pill badge-info'
        }
    },
  },
}
</script>

<style scoped>
  .mt-3 {
    margin-top: 1rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }
  .mr-3 {
    margin-right: 1rem;
  }
  .card {
    width: 20rem;
  }
  .card-body {
    padding: 1.25rem;
  }
  .badge {
    padding: .25rem .5rem;
    font-size: .75rem;
  }
  .btn {
    padding: .375rem .75rem;
    font-size: .875rem;
  }
  .btn-sm {
    padding: .25rem .5rem;
    font-size: .75rem;
  }
</style>


